"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePartnershipInterstitial = void 0;
const usePartnershipInterstitialBase_hook_1 = require("./usePartnershipInterstitialBase.hook");
const usePartnershipInterstitial = ({ partnershipData }) => (0, usePartnershipInterstitialBase_hook_1.usePartnershipInterstitialBase)({ partnershipData });
exports.usePartnershipInterstitial = usePartnershipInterstitial;
//# sourceMappingURL=usePartnershipInterstitial.hook.js.map